export default "__VITE_ASSET__Bnk6OR60__"